import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  withHandlers,
} from 'recompose';
import reactCSS from 'reactcss';
import Modal from '@ux/modal';
import { Settings, SettingsToggle } from '../settings';
import Header from '../header';
import CookieToggleGroup from '../cookie-toggle-group';
import { Container } from '@ux/grid';
import { Content } from '@ux/typeface';
import Button, { Kind, Size } from '@ux/button';
import { FormattedMessage } from 'react-intl';
import { withBreakpoints } from '@ux/responsive';
import { getStyles } from '@ux/style-utils';
import stylesheet from './PrivacyModal.stylesheet';
import { Field, Form } from 'redux-form';
import * as r from 'ramda';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinMd,
  desktop: props.isMinLg,
});

export const PurePrivacyModal = ({
  styles,
  expanded,
  theme,
  isMinMd,
  isMinLg,
  cookies,
  form,
  privacyPolicyUrl,
  buttonSize,
  isOpen,
  onAccept,
  onDecline,
}) => (
  <Modal
    theme={theme}
    isOpen={isOpen}
  >
    <Content
      key="privacy"
      theme={theme}
      component="div"
      className="UPM__PrivacyModal"
    >
      <div style={styles.inner}>
        <Form onSubmit={form.handleSubmit}>
          <Container theme={theme}>
            <div style={styles.header}>
              <Header
                theme={theme}
                intlNamespace="modal"
                expanded={expanded}
                privacyPolicyUrl={privacyPolicyUrl}
              />
            </div>
            <div style={styles.settings}>
              <Settings
                theme={theme}
                expanded={expanded}
                isMinMd={isMinMd}
                isMinLg={isMinLg}
              >
                <CookieToggleGroup
                  theme={theme}
                  cookies={cookies}
                  isMinMd={isMinMd}
                  isMinLg={isMinLg}
                  lgCols={6}
                />
              </Settings>
            </div>
            <div style={styles.actions}>
              <span style={styles.decline}>
                <Field
                  name="expanded"
                  // eslint-disable-next-line react/jsx-no-bind
                  component={({ input }) => (
                    <SettingsToggle
                      buttonSize={buttonSize}
                      theme={theme}
                      expanded={input.value}
                      // eslint-disable-next-line react/jsx-no-bind
                      onClick={() => input.onChange(r.not(input.value))}
                    />
                  )}
                />
              </span>
              <div style={styles.buttons}>
                <span style={styles.button}>
                  <Button
                    theme={theme}
                    kind={Kind.POSITIVE}
                    size={buttonSize}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={onDecline}
                  >
                    <FormattedMessage id="cookie.decline"/>
                  </Button>
                </span>
                <span style={styles.button}>
                  <Button
                    theme={theme}
                    kind={Kind.POSITIVE}
                    size={buttonSize}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={onAccept}
                  >
                    {r.ifElse(
                      r.equals(true),
                      () => (
                        <FormattedMessage id="cookie.confirm"/>
                      ),
                      () => (
                        <FormattedMessage id="cookie.accept"/>
                      ),
                    )(expanded)}
                  </Button>
                </span>
              </div>
            </div>
          </Container>
        </Form>
      </div>
    </Content>
  </Modal>
);

export const enhance = compose(
  setDisplayName('PrivacyModal'),
  withBreakpoints,
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
    buttonSize: r.ifElse(
      r.propEq('isMinLg', true),
      r.always(Size.MD),
      r.always(Size.SM),
    )(ownerProps),
    isOpen: r.not(ownerProps.dismissed),
  })),
  withHandlers({
    onAccept: ({ form }) => () => {
      form.change('submit', 'accept');
      setTimeout(() => {
        form.handleSubmit();
      }, 10);
    },
    onDecline: ({ form }) => () => {
      form.change('submit', 'decline');
      setTimeout(() => {
        form.handleSubmit();
      }, 10);
    },
  }),
);

export default enhance(PurePrivacyModal);
